/**
 * Notifier util
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var Class = require('Class');
    var core = require('core');
    var config = require('config');

    var successDeposit = require('notifications/successDeposit.notification');
    var showLoginPopup = require('notifications/showLogin.notification');

    module.exports = Class.create({

        started: false,
        queue: [],
        callbacks: {},

        initialize: function() {
            // Subscribe to application notifications
            this.addCallback('successDeposit', successDeposit);
            this.addCallback('showLogin', this.showLogin);

            core.log('Push notifier initialized');

            core.on('server:message', this._handleMessages.bind(this));
            core.on('app:message', this._handleMessages.bind(this));
            core.on('app:rendered', this.start.bind(this));
        },

        start: function() {
            this.started = true;

            for (var i = 0, l = this.queue.length; i < l; i++) {
                this._handleMessages(this.queue.shift());
            }

            core.log('Push notifier started');
        },

        stop: function() {
            this.started = false;
        },

        /**
         * Add listener to a specific server/application message
         * @param {Number|String|Array} messageID - message ID(s) to listen to
         * @param {Function|Object} callback -  callback function or notifier object with callback
         * @param {String} [callbackFnName='notify']- callback name in notifier object
         */
        addCallback: function(messageID, callback, callbackFnName) {
            var callbackFn = _.isFunction(callback) ? callback : callback[callbackFnName || 'notify'];

            var addCallback = function(msg) {
                if (!this.callbacks[msg]) {
                    this.callbacks[msg] = [];
                }
                this.callbacks[msg].push(callbackFn.bind(callback));
            }.bind(this);

            if (_.isArray(messageID)) {
                messageID.forEach(addCallback);
            } else {
                addCallback(messageID);
            }
        },

        /**
         * Notification handler callback
         * @private
         * @callback notifyCallback
         * @param {Object|String} msg
         */
        _handleMessages: function(msg) {
            var data = {};

            if (!this.started) {
                return this.queue.push(msg);
            }

            try {
                data = _.isString(msg) ? JSON.parse(msg) : msg;
            } catch (e) {
                data = {
                    ID: -1,
                    data: {
                        errorCode: -1,
                        message: 'Open API: Response parse error'
                    }
                };
            }

            if (this.callbacks[data.ID]) {
                this.callbacks[data.ID].forEach((callback) => {
                    callback(data, this);
                });
            }
        },

        showLogin: function(options) {
            var loginPage = config.get('loginPage');
            var separator = loginPage && loginPage.indexOf('?') === -1 ? '?' : '&';
            var afterLoginUrl = options?.data?.afterLoginUrl ?
                separator + 'afterLoginUrl=' + encodeURIComponent(options.data.afterLoginUrl) : '';

            if (loginPage) {
                window.Playtech.API.popup.closePopups();
                core.navigate(loginPage + afterLoginUrl);
            } else {
                showLoginPopup.notify(options);
            }
        }
    });
});
